import {
  Button,
  CloseButton,
  Divider,
  Flex,
  Heading,
  useToast,
} from "@chakra-ui/react";
import Modal from "../overlay/Modal";
import Overlay from "../overlay/OverLay";
import InputComponent from "../UI/Input";
import { useState } from "react";
import { updateDesignation } from "../../util/http";

export default function EditDesignation({ show, id, role }) {
  const [loading, setLoading] = useState(false);
  const [designation, setDesignation] = useState(role || "");
  const toast = useToast();

  function closeMenu() {
    show(false);
  }

  async function editHandler() {
    const data = { designation };

    try {
      setLoading(true);
      await updateDesignation(id, data);
      closeMenu();
      window.location.reload();
      toast({
        title: `Designation updated`,
        description: ``,
        status: "success",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast({
        title: `Error`,
        description: `${
          error?.response?.data.message || "something went wrong"
        }`,
        status: "error",
        duration: 3000,
        isClosable: true,
        position: "top-right",
      });
    }
  }

  return (
    <>
      <Overlay hide={closeMenu} />
      <Modal hide={closeMenu}>
        <Flex w="100%" align="start" direction="column" gap="1rem" py="1rem">
          <Flex w="100%" align="center" justify="space-between">
            <Heading size="md" color="var(--container_color)" fontWeight="bold">
              Edit Designation
            </Heading>
            <CloseButton onClick={closeMenu} />
          </Flex>
          <Divider />
          <InputComponent
            label="Designation"
            onChange={(e) => setDesignation(e.target.value)}
            value={designation}
          />
          <Button
            variant="solid"
            bg="brand.900"
            color="white"
            isLoading={loading}
            loadingText=""
            onClick={editHandler}
          >
            Save Update
          </Button>
        </Flex>
      </Modal>
    </>
  );
}
